// extracted by mini-css-extract-plugin
module.exports = {"Title":"EventFeature_Title__3DoXF","Features":"EventFeature_Features__2i06a","Item":"EventFeature_Item__3Y87c"};